import script from "./AdminProductTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductTableRow.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductTableRow.vue?vue&type=style&index=0&id=53c5effb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c5effb"]])

export default __exports__